import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';

import { useMetrics } from '../../hooks/useMetrics';

export const LiveActionsDisabledContext = createContext({
  showMediaIsDisabled: {} as boolean,
  setShowMediaIsDisabled: {} as Dispatch<SetStateAction<boolean>>,
  openFirstAiResponse: {} as (gameId: string, slideId: string) => void,
  setOpenFirstAiResponseHandler: {} as Dispatch<
    SetStateAction<((gameId: string, slideId: string) => void) | undefined>
  >,
});

const LiveActionsDisabledProvider = ({ children }: { children: React.ReactNode }) => {
  const metrics = useMetrics();
  const [showMediaIsDisabled, setShowMediaIsDisabled] = useState(false);
  const [openFirstAiResponseHandler, setOpenFirstAiResponseHandler] = useState<
    ((gameId: string, slideId: string) => void) | undefined
  >(undefined);

  const openFirstAiResponse = useMemo(
    () => (gameId: string, slideId: string) => {
      if (openFirstAiResponseHandler) {
        metrics.logEvent('Live.OpenFirstAiResponse', { gameId, slideId });
        openFirstAiResponseHandler(gameId, slideId);
      }
    },
    [openFirstAiResponseHandler, metrics],
  );

  const value = useMemo(
    () => ({
      setShowMediaIsDisabled,
      showMediaIsDisabled,
      openFirstAiResponse,
      setOpenFirstAiResponseHandler,
    }),
    [showMediaIsDisabled, openFirstAiResponse],
  );
  return (
    <LiveActionsDisabledContext.Provider value={value}>
      {children}
    </LiveActionsDisabledContext.Provider>
  );
};

export default LiveActionsDisabledProvider;
